import { AllianzAccountIsOnCancellationProcessEntity } from '../entities/allianz-account-is-on-cancellation-process-entity';

export default class AllianzAccountIsOnCancellationProcessState {
  loaded = false;

  allianz_account_is_on_cancellation_process: AllianzAccountIsOnCancellationProcessEntity = {
    is_on_cancellation_process: false,
  };
}
